import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import { RoleAction, RolePermissionSubject, Shift } from '@wilson/interfaces';
import { IsShiftSubmittedOrAcceptedPipe } from '@wilson/non-domain-specific/shift-helpers/core';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ShiftDeleteConfirmationService } from '../services/shift-delete-confirmation/shift-delete-confirmation.service';
import { ShiftDeletionEvaluatorPipe } from './shift-deletion-evaluator.pipe';

@Component({
  selector: 'wilson-delete-shift-action',
  imports: [
    CommonModule,
    NzDropdownModule,
    TranslatePipe,
    AuthorizationModule,
    NzTooltipModule,
    ShiftDeletionEvaluatorPipe,
    IsShiftSubmittedOrAcceptedPipe,
  ],
  providers: [],
  templateUrl: './delete-shift-action.component.html',
  styleUrl: './delete-shift-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteShiftActionComponent {
  @Output()
  triggered = new EventEmitter<void>();

  @Input({ required: true }) shift!: Shift | null;

  protected shiftDeleteConfirmationService = inject(
    ShiftDeleteConfirmationService,
  );
  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;

  protected async deleteButtonClicked(): Promise<void> {
    if (!this.shift) {
      return;
    }

    const confirmed =
      await this.shiftDeleteConfirmationService.confirmShiftDelete({
        name: this.shift.name,
        state: this.shift.state,
        activities: this.shift.activities,
      });

    if (confirmed) {
      this.triggered.emit();
    }
  }
}
